import { Suspense } from "react";
import { Await } from "react-router-dom";
import { ArticleContext } from "@app/types/Page";
import CustomError from "@components/Error/CustomError";
import Spinner from "@components/Spinner/Spinner";
import { CustomContext, useRouteContext } from "@sphtech/web2-core/ssr";

import ArticleContent from "./ArticleContent";

export default function ArticlePage(): React.ReactElement {
  const { context }: CustomContext<ArticleContext> = useRouteContext();

  return (
    <Suspense fallback={<Spinner />}>
      <Await resolve={context} errorElement={<CustomError />}>
        {({
          kind,
          error,
          data: {
            cook: {
              data: { context, seeAlso },
            },
            breakingNews,
            sectionNews,
          },
        }) => {
          return kind !== "art" || error ? (
            <h1>Missing context</h1>
          ) : (
            <ArticleContent
              {...{ context, breakingNews, sectionNews, seeAlso }}
            />
          );
        }}
      </Await>
    </Suspense>
  );
}
